import React from "react";
import { Link } from "react-router-dom";
import { Home, Search } from "lucide-react";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center px-6 text-center">
      <p className="text-yellow-400 font-mono text-sm tracking-widest uppercase mb-4">Erro 404</p>
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4">
        Página não encontrada
      </h1>
      <p className="text-zinc-400 text-base max-w-md mb-10">
        O endereço que você tentou acessar não existe ou foi movido. Confira os links abaixo para continuar navegando.
      </p>
      <div className="flex flex-col sm:flex-row gap-4">
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-yellow-400 px-8 py-3 font-semibold text-zinc-950 transition-colors hover:bg-yellow-300"
        >
          <Home className="h-4 w-4" />
          Voltar ao início
        </Link>
        <Link
          to="/quiz"
          data-testid="not-found-quiz-link"
          className="inline-flex items-center justify-center gap-2 rounded-full border border-zinc-700 px-8 py-3 font-semibold text-white transition-colors hover:border-yellow-400 hover:text-yellow-400"
        >
          <Search className="h-4 w-4" />
          Fazer o Quiz WING
        </Link>
      </div>
    </div>
  );
}
